module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-02f8e194e5b9622eae430610a7fde076.webp";